/*
 * FILE: unified_ui/src/stores/onboarding.ts
 * PURPOSE: Pinia store for the one-time onboarding modal («Кибер Бот»). Reads
 *          the localStorage flag on first load; any interaction marks it seen
 *          so the modal never shows again on the same browser.
 * OWNS: `botsuite.onboarding.seen` localStorage flag + seen state.
 * EXPORTS: useOnboardingStore (seen, complete)
 * DOCS: docs/architecture/components/unified-ui.md
 */
import { defineStore } from 'pinia'
import { ref } from 'vue'

const SEEN_KEY = 'botsuite.onboarding.seen'

function getInitialSeen(): boolean {
  if (typeof localStorage === 'undefined') return false
  return localStorage.getItem(SEEN_KEY) === '1'
}

export const useOnboardingStore = defineStore('onboarding', () => {
  const seen = ref<boolean>(getInitialSeen())

  /** Mark onboarding as finished — persists immediately, no other side effects. */
  function complete() {
    if (typeof localStorage !== 'undefined') {
      localStorage.setItem(SEEN_KEY, '1')
    }
    seen.value = true
  }

  return { seen, complete }
})
